export const locale = {
  captcha: `Protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.`,
  something_wrong: `Something went wrong! Please contact us&nbsp;at&nbsp;<a href="mailto:newsletter@meduza.io">newsletter@meduza.io</a>, <br/>and we&rsquo;ll get you signed up&nbsp;fo&nbsp;our newsletter.`,
  action: 'Subscribe!',
  already_message: 'Already subscribed',
  error_message: `Something went wrong! Please contact us&nbsp;at&nbsp;<a href="mailto:newsletter@meduza.io">newsletter@meduza.io</a>, <br/>and we&rsquo;ll get you signed up&nbsp;fo&nbsp;our newsletter.`,
  iframe_src: 'https://meduza.io/static/test/email_en.htm',
  label: 'Email',
  success_message: `<span>Excellent!</span> Now you’ve&nbsp;got to&nbsp;verify that email address.`,
  title:
    'One feature story every month. From Budapest to&nbsp;Bishkek. Direct to&nbsp;your inbox.',
  head_title: 'We&nbsp;got'
}
